import { jsx } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { ReactComponent as SvgSpinner } from '../../shared/assets/spinner.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';

const Spinner = ({ className = '' }) => (jsx(SvgSpinner, { className: classNames('spinner', className) }));

export { Spinner };
